<template>
  <BModal
    id="download-mutation-transaction-komcards"
    ref="download-mutation-transaction-komcards"
    hide-footer
    hide-header
    centered
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    @hidden="onReset"
  >
    <ValidationObserver #default="{ invalid }">
      <BRow class="justify-center my-1 flex flex-column">
        <BCol class="d-flex justify-content-center mb-2">
          <strong class="text-black text-xl">
            Download Mutasi
          </strong>
        </BCol>
        <BCol>
          <BFormGroup>
            <template #label>
              <span
                class="text-black font-medium text-base"
              >Rentang Waktu</span>
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Rentang Waktu"
              rules="required"
            >
              <DateRangePicker
                ref="picker"
                v-model="dateRange"
                :locale-data="locale"
                :ranges="ranges"
                :opens="'center'"
                class="w-full"
                :max-date="new Date()"
              >
                <template v-slot:input="picker">
                  {{ SLASH_DATE(picker.startDate) }} -
                  {{ SLASH_DATE(picker.endDate) }}
                </template>
              </DateRangePicker>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
        <BCol>
          <BFormGroup>
            <template #label>
              <div class="text-black flex items-center">
                <span class="font-medium text-base">Kartu</span>
                <span class="text-primary">*</span>
              </div>
            </template>
            <ValidationProvider
              name="Kartu"
              rules="required"
            >
              <template #default="{ errors }">
                <MultiSelect
                  id="cards"
                  v-model="cardId"
                  placeholder="Pilih Kartu"
                  :no-label="true"
                  :options="optionsCards"
                ><template #no-options>
                   Tidak ada kartu
                 </template>
                  <template #placeholder="slotProps">
                    <b-spinner
                      v-if="isLoading"
                      variant="primary"
                      label="Spinning"
                      class="mr-1"
                      small
                    />
                    <div
                      class="grow m-0 text-[1rem] text-[#626262] font-medium truncate"
                    >
                      {{
                        slotProps.selected.length > 0
                          ? slotProps.selected
                            .map(item => item.split('|')[0])
                            .join(', ')
                          : slotProps.initialText
                      }}
                    </div>
                  </template>
                  <template #option="cards">
                    <div
                      v-for="(optionValue, index) in cards.options"
                      :key="index"
                      class="checkbox-wrapper"
                    >
                      <b-form-checkbox :value="optionValue">
                        <div class="flex items-center flex-row ml-[4px]">
                          <img
                            class="w-6 mr-1"
                            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/card.svg"
                            alt="komcard"
                          >
                          <div class="flex items-center">
                            <span class="text-black mr-[4px]">{{
                              cards.optionTexts[index].split('*')[0]
                            }}</span>
                            <span class="text-[#828282]">
                              *{{
                                cards.optionTexts[index].split('*')[1]
                              }}
                            </span>
                          </div>
                        </div>
                      </b-form-checkbox>
                    </div>
                  </template>
                </MultiSelect>
                <small class="text-danger">{{ errors[0] }}</small>
              </template>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
        <BCol>
          <BFormGroup>
            <template #label>
              <span class="text-black font-medium text-base">Output Data Mutasi</span>
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Kompoints"
              rules="required"
            >
              <BFormRadioGroup
                v-model="isKompoints"
                :options="optionsOutputKompoints"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
      </BRow>
      <BRow class="mb-1">
        <BCol cols="6">
          <BButton
            variant="outline-primary"
            block
            @click="onClose"
          >
            Batal
          </BButton>
        </BCol>
        <BCol cols="6">
          <BButton
            :disabled="invalid || isLoading"
            :variant="invalid || isLoading ? 'secondary' : 'primary'"
            type="submit"
            block
            @click.prevent="onSubmit"
          >
            <BSpinner
              v-if="isLoading"
              variant="light"
              small
            />
            Download
          </BButton>
        </BCol>
      </BRow>
    </ValidationObserver>
  </BModal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import { required } from '@validations'
import {
  LABELDAY,
  LABELMONTH,
  SLASH_DATE,
  YYYYMMDD,
  DASH_DATE,
} from '@/libs/formatDate'
import {
  firstDateOfMonth,
  last60,
  last90,
  lastDateOfLastMonth,
  lastMonth,
  today,
} from '@/store/helpers'
import { newAxiosIns } from '@/libs/axios'
import { MultiSelect } from '@/views/components/select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    MultiSelect,
    DateRangePicker,
  },
  props: {
    listCards: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      SLASH_DATE,
      YYYYMMDD,
      DASH_DATE,
      required,
      cardId: [], // Initialize as empty array for MultiSelect
      isLoading: false,
      isKompoints: false,
      optionsOutputKompoints: [
        { text: 'Tanpa Kompoint', value: false },
        { text: 'Dengan Kompoint', value: true },
      ],
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      dateRange: {
        startDate: firstDateOfMonth,
        endDate: today,
      },
      ranges: {
        'Bulan ini': [firstDateOfMonth, today],
        'Bulan lalu': [lastMonth, lastDateOfLastMonth],
        '2 Bulan terakhir': [last60, today],
        '3 Bulan terakhir': [last90, today],
      },
    }
  },
  computed: {
    optionsCards() {
      const result = {
        text: [],
        value: [],
      }
      this.listCards.forEach(card => {
        result.text.push(
          `${card.name} *${this.splitCardNumber(card.card_number)}`,
        )
        result.value.push(
          `${card.name} *${this.splitCardNumber(card.card_number)}|${card.id}`,
        )
      })
      return result
    },
  },
  methods: {
    async onSubmit() {
      this.isLoading = true
      const url = '/komcards/api/v1/card/mutation/export'
      const cardIds = this.cardId.map(card => Number(card.split('|')[1]))
      const body = {
        card_ids: cardIds,
        start_date: YYYYMMDD(this.dateRange.startDate),
        end_date: YYYYMMDD(this.dateRange.endDate),
        is_kompoints: this.isKompoints,
      }

      // Make API call to export mutation data
      await newAxiosIns
        .post(url, body)
        .then(res => {
          const { data } = res.data

          if (data) {
            // Generate filename based on date range
            const filename = `Rincian_Mutasi_${DASH_DATE(
              this.dateRange.startDate,
            )}_${DASH_DATE(this.dateRange.endDate)}`

            // Create download link and trigger download
            const a = document.createElement('a')
            a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data.base64_object}`
            a.download = `${filename}.xlsx` // Use .xlsx extension
            a.click()

            this.dateRange = {
              startDate: firstDateOfMonth,
              endDate: today,
            }
            this.$toast_success({ message: 'Data berhasil di export' })
          } else {
            this.$toast_success({
              message: 'File akan dikirimkan ke email yang terdaftar di akun kamu. Mohon tunggu',
            })
          }
        })
        .catch(() => {
          this.isLoading = false
          this.$toast_error({
            message:
              'Terjadi kesalahan sementara. Mohon coba lagi dalam beberapa saat',
          })
        })
        .finally(() => {
          this.isLoading = false
          this.$bvModal.hide('download-mutation-transaction-komcards')
        })
    },
    onClose() {
      this.$bvModal.hide('download-mutation-transaction-komcards')
    },
    onReset() {
      this.cardId = null
    },
    splitCardNumber(number) {
      return number.split(' ').pop()
    },
  },
}
</script>
